import post from '@/api/post'
export default {
  getAllEvents (params) {
    params = params || {limit: 100, page: 1}
    return post('get_events', {
      rows: params.limit,
      page: params.page,
      sord: 'DESC',
      sidx: 'dt_event'
    }).then(response => {
      if (response.data.data.rows && Array.isArray(response.data.data.rows)) {
        response.data.data.rows = response.data.data.rows.map((item) => ({
          id: parseInt(item.id),
          date: new Date(item.date_event.replace(/-/g, '/')),
          date_tracker: new Date(item.date_tracker.replace(/-/g, '/')),
          name: item.event_desc,
          imei: item.imei,
          obj_name: item.name,
          type: item.type,
          lat: item.lat,
          lng: item.lng
        }))
      }
      return response.data.data
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/services/objects/events/index.js